module.exports = __webpack_public_path__ + "static/media/goUp.bc353b81.svg";